import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { axios, queryClient } from '@apps-common/lib'
import { IUnitTaskQueueModel, IUnitTaskQueueSearchParamsModel } from '@apps-common/types/portal/unit-tasks'

export const QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_INFINITE = (taskGroupId?: number, model?: IUnitTaskQueueSearchParamsModel) =>
  ['searchUnitTaskQueueInfinite', taskGroupId, model?.status, model?.startDate, model?.endDate, model?.orderBy].filter(Boolean)

export const searchUnitTaskQueueInfinite = async (
  taskGroupId: number,
  model: IUnitTaskQueueSearchParamsModel
): Promise<IUnitTaskQueueModel[]> =>
  axios.post('/management/UnitProgramTask/SearchTaskQueue', { taskGroupId, ...model }).then((res) => res.data?.data)

type Props = {
  enabled: boolean
  taskGroupId: number
  model: IUnitTaskQueueSearchParamsModel
}

export const useManagementSearchUnitTaskQueueInfinite = ({ enabled = true, taskGroupId, model }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage } = useInfiniteQuery({
    enabled,
    staleTime: 0,
    gcTime: 0,
    queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_INFINITE(taskGroupId, model),
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) => searchUnitTaskQueueInfinite(taskGroupId, { ...model, skip: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < model.take) {
        return null
      }

      return allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
    }
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_INFINITE() })
    },
    []
  )

  return {
    isLoading,
    isFetching,
    isRefetching,
    isError,
    data,
    refetch,
    fetchNextPage,
    hasNextPage
  }
}
